


















import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {GetPatientOutComeList} from "@/api/patient"
import AddOrEdit from './addOrEdit'

@Component({
	components: {AddOrEdit}
})
export default class XX extends AbpBase {
	@Prop() patient: any

	data:any = {}
	loading = false
	tableData = []
	addOrEditShow = false
	type = ''
	columns = [
		{
			title: '类型',
			key: 'type',
			render:(h:any,params:any) =>{
				return h('span', this.getType(params.row))
			}
		}, {
			title: '时间',
			key: 'inputDate',
			render:(h:any, params:any) => {
				return h('span', this.formatDate(params.row.inputDate))
			}
		}, {
			title: '原因',
			key: 'reason'
		},{
			width: 95,
			title: '操作',
			render:(h:any, params:any) => {
				return h('Button', {
					props:{
						type:'primary'
					},
					on:{
						click:()=>{
							this.editOne(params.row)
						}
					}
				}, '编辑')
			}
		},
	]

	saveSuccess(){
		this.addOrEditShow = false
		this.init()
	}

	getType(row:any){
		let res = ""
		res += row.type + '(' + row.typeReason
		if (row.typeReason === '死亡') {
			res += `--${row.deathType}`
		}
		res += ')'

		return res
	}

	addOne(){
		this.data = {
			mode: 'add',
			patient: this.patient
		}
		this.addOrEditShow = true
	}

	created() {
		this.init()
	}

	private async init() {
		this.loading = true
		let query: any = {
			PatientId: this.patient.id
		}
		let res = await GetPatientOutComeList(query)
		this.tableData = res.objects
		this.loading = false
	}

	private editOne(row: any) {
		this.data = {
			mode: 'edit',
			patient: this.patient,
			item: row
		}
		this.addOrEditShow = true
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/outCome/index.vue